import React from 'react';
import { Step, StepProps } from '.';
import { Cart } from '../Capsules/Envelopes';
import { CheckoutWizardRouterProps } from '../CheckoutWizard/CheckoutWizardInterfaces';

interface WizardStepsProps extends CheckoutWizardRouterProps {
    cart: Cart;
}

const WizardSteps: React.FC<WizardStepsProps> = ({ cart, route, setRoute }) => {
    // const isCartEmpty = getCartEmpty(cart.envelopes);
    const onClick = (count: StepProps['count']) => {
        switch (count) {
            case '1':
                return setRoute('amount');
            case '2':
                return setRoute('envelopes');
            case '3':
                return setRoute('cart');
        }
    };

    if (route === 'thank-you') {
        return null;
    }

    return (
        <div className="flex items-center justify-evenly min-h-[80px] border-0 border-b border-solid border-utility-separator smallTablet:hidden">
            <Step
                onClick={onClick}
                state={route === 'amount' ? 'selected' : 'completed'}
                count={'1'}
                name={'Gift Amount'}
            />
            <Step
                onClick={onClick}
                state={
                    route === 'amount'
                        ? 'disable'
                        : route === 'envelopes'
                          ? 'selected'
                          : 'completed'
                }
                count={'2'}
                name={'Gift Purpose'}
            />
            <Step
                onClick={onClick}
                state={route === 'cart' ? 'selected' : 'disable'}
                count={'3'}
                name={'Gift Summary'}
            />
        </div>
    );
};

export default WizardSteps;
